export function getValue(value, genders) {
  return genders.find(g => g.id === value)?.text || ''
}
